import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
export default function ConfirmTableClosingModal(_ref) {
  let isOpen = _ref.isOpen,
    onConfirm = _ref.onConfirm,
    setTableId = _ref.setTableId;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleConfirm = () => {
    onConfirm();
    setTableId('');
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => setTableId(''),
    isOpen: isOpen,
    noPadding: true,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      onClick: handleConfirm,
      variant: "contained",
      'custom-attribute': '515-ConfirmTableClosingModal'
    }, t('allocations.yes_close')),
    title: t('allocations.close_alloc_table')
  });
}